import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer, showErrorMessage, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {Alert, AlertTitle} from "@mui/lab";
import {css} from "@emotion/css";
import {FormControl} from "@mui/material";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import React from "react";
import {useState} from "react";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {UserService} from "../../serverService/userService/UserService";
import {useAuthState} from "../../context/AuthContext";
import {useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function ChangeUserUsername(
    {
        hint = "بعد از تغییر نام کاربری،کاربر به صورت خودکار از برنامه خارج می شود و لازم است مجددا با نام کاربری جدید وارد برنامه شود.",
        username,
        setUsername
    }
) {
    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new UserService()
    const {fundID} = useAuthState()
    const {id: userID} = useParams()
    const [newUserName, setNewUserName] = useState("")


    function handleUpdateUserName() {
        if (checkInputs()) {
            loading.show()
            service.updateUserName(fundID, userID, newUserName)
                .then(response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                    setUsername(newUserName)
                    setNewUserName("")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkInputs() {
        let message = ""
        let state = true
        if (newUserName.length < 8) {
            message = "نام کاربری جدید حداقل باید 8 کاراکتر باشد."
        } else if (username === newUserName) {
            message = "نام کاربری وارد شده تکراری می باشد."
        } else
            state = true
        if (message.length > 0)
            showWarningMessage(message)
        return state

    }


    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"ویرایش نام کاربری"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateUserName}
                >
                    <RaikoGridOneColumn>
                        <Alert severity="error" className={css`width: 100%;`}>
                            <AlertTitle>لطفا نکات زیر را مورد توجه قرار دهید:</AlertTitle>
                            <div className={css`display: flex;
                              flex-direction: column;
                              gap: 8px;
                            `}>
                                <span>{hint}</span>

                            </div>
                        </Alert>
                        <RaikoGridTwoColumn>
                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    disabled={true}
                                    labelText={"نام کاربری"}
                                    placeHolder={"لطفا کاربری مورد نظر را وارد نمایید..."}
                                    value={username}
                                    onChange={e => setUsername(e.target.value)}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام کاربری جدید"}
                                    placeHolder={"لطفا کاربری مورد نظر را وارد نمایید..."}
                                    value={newUserName}
                                    onChange={e => setNewUserName(e.target.value)}
                                />
                            </FormControl>
                        </RaikoGridTwoColumn>

                    </RaikoGridOneColumn>

                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}